module.exports = __webpack_public_path__ + "static/three-a2993e1a04137c86409a1bd1eb043596.png";